<template>
    <div class="talent">
        <siteHeader />
        <img src="@/assets/01.jpg" alt="main image" class="main-image">
        <div class="talent-container">
            <div class="talent-intro-card">
                <h2 class="card-title">人才招聘 <span class="english-subtitle">Talent recruitment</span></h2>
                <div class="talent-content-area">
                    <div class="talent-content">
                        <h3 class="section-title">招聘职位</h3>
                        <div class="job-list">
                            <div class="job-item" v-for="job in jobList" :key="job.id">
                                <div class="job-details">
                                    <div class="job-title-location">
                                        <h4 class="job-title">{{ job.position }}</h4>
                                        <p class="job-location">{{ job.workplace }}/{{ job.numbers }}</p>
                                    </div>
                                    <div class="job-compensation-education">
                                        <p class="job-compensation">{{ job.compensation }}</p>
                                        <p class="job-education">{{ job.education }}</p>
                                    </div>
                                    <div class="job-detail-link">
                                        <router-link :to="{ path: '/job/' + job.id, query: { rows: [job] } }">了解详情
                                            ></router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p v-if="!jobList || jobList.length === 0">暂无招聘信息</p>

                        <div class="pagination">
                            <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">Previous</button>
                            <button v-for="page in totalPages" :key="page" @click="goToPage(page)"
                                :class="{ active: currentPage === page }">
                                {{ page }}
                            </button>
                            <button @click="goToPage(currentPage + 1)"
                                :disabled="currentPage === totalPages">Next</button>
                            <select v-model="itemsPerPage" @change="fetchJobs(currentPage)">
                                <option value="8">8条/页</option>
                                <option value="10">10条/页</option>
                                <option value="15">15条/页</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <siteFooter />
    </div>
</template>

<script>
import siteHeader from '../components/SiteHeader.vue'
import siteFooter from '../components/SiteFooter.vue'
import { getLtTalentRecruitmentDalist } from '@/api/website'

export default {
    name: 'TalentPage',
    components: {
        siteHeader,
        siteFooter
    },
    data() {
        return {
            jobList: [],
            currentPage: 1,
            itemsPerPage: 8,
            totalItems: 0
        }
    },
    mounted() {
        this.fetchJobs(this.currentPage)
    },
    methods: {
        async fetchJobs(pageNum = 1) {
            this.currentPage = pageNum;
            try {
                const response = await getLtTalentRecruitmentDalist({ pageNum: this.currentPage, pageSize: this.itemsPerPage });
                if (response && response.code === 200) {
                    this.jobList = response.rows;
                    this.totalItems = response.total;
                } else {
                    this.jobList = [];
                    this.totalItems = 0;
                    console.error('Failed to fetch job listings:', response.msg);
                }
            } catch (error) {
                this.jobList = [];
                this.totalItems = 0;
                console.error('Error fetching job listings:', error);
            }
        },
        goToPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.fetchJobs(page);
            }
        }
    },
    computed: {
        totalPages() {
            return Math.ceil(this.totalItems / this.itemsPerPage);
        }
    }
}
</script>

<style scoped>
.main-image {
    width: 79.17%;
    max-width: 1520px;
    height: auto;
    display: block;
    margin: 0 auto;
}

.talent-container {
    display: flex;
    padding: 20px;
    max-width: 1200px;
    margin: 20px auto;
    margin-top: -50px;
    flex-direction: column;
}

.talent-intro-card {
    background: white;
    border-radius: 12px;
    padding: 32px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.talent-intro-card .card-title {
    color: #ac6249;
    font-size: 24px;
    margin-bottom: 16px;
    padding-bottom: 8px;
    position: relative;
    display: inline-block;
}

.talent-intro-card .card-title::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #ac6249;
}

.talent-intro-card .english-subtitle {
    font-size: 20px;
    color:#ac6249;
    font-weight: normal;
}

.talent-content-area {
    display: flex;
    gap: 40px;
    margin-top: 20px;
}

.talent-content {
    flex-grow: 1;
}

.section-title {
    font-size: 20px;
    color: #ac6249;
    margin-bottom: 20px;
    text-align: center;
    /* Centered title as in screenshot */
}

.job-list {
    display: grid;
    grid-template-columns: 1fr;
    /* Keep single column layout */
    gap: 10px;
    /* Keep gap between items */
    justify-items: center;
    /* Center grid items horizontally */
}

.job-item {
    border: 1px solid #eee;
    /* Keep border */
    border-radius: 8px;
    /* Keep border radius */
    padding: 10px 15px;
    /* Keep padding */
    background-color: #ac6249   ;
    /* Dark blue background */
    color: white;
    /* White text */
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    /* Keep smaller shadow */
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    /* Keep transition */
    display: flex;
    /* Use flexbox for horizontal layout */
    align-items: center;
    /* Vertically align items */
    justify-content: space-between;
    /* Distribute space between job-details and job-detail-link */
    max-width: 550px;
    /* Keep maximum width */
    width: 100%;
    /* Allow it to be responsive below max-width */
}

.job-item:hover {
    transform: translateY(-3px);
    /* Keep hover effect */
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
    /* Keep hover shadow */
}

.job-details {
    display: flex;
    /* Keep job-details as flex */
    align-items: center;
    /* Vertically align internal items */
    flex-grow: 1;
    /* Allow job-details to take available space */
    justify-content: space-between;
    /* Distribute space between job-title-location and job-compensation-education */
    /* Gap between internal items will now be handled by justify-content */
    margin-right: 10px;
    /* Add some space before the detail link */
}

.job-title-location {
    display: flex;
    flex-direction: column;
    /* Stack title and location vertically */
    align-items: flex-start;
    /* Align text to the left */
    justify-content: center;
    /* Vertically center content within this column */
    gap: 3px;
    /* Adjusted gap between title and location */
}

.job-title {
    font-size: 1em;
    /* Keep font size */
    color: white;
    /* Keep color */
    margin-bottom: 0;
    /* Use gap in parent */
    font-weight: bold;
    /* Keep title bold */
}

.job-location {
    font-size: 0.8em;
    /* Keep font size */
    color: rgba(255, 255, 255, 0.8);
    /* Keep color */
    margin-bottom: 0;
    /* Keep margin */
}

.job-compensation-education {
    display: flex;
    flex-direction: column;
    /* Stack compensation and education vertically */
    align-items: flex-start;
    /* Align text to the left within this column */
    justify-content: center;
    /* Vertically center content within this column */
    gap: 3px;
    /* Adjusted gap between compensation and education */
}

.job-compensation {
    font-size: 1em;
    /* Keep font size */
    color: white;
    /* Keep color */
    margin-bottom: 0;
    /* Use gap in parent */
    font-weight: bold;
    /* Make compensation bold */
}

.job-education {
    font-size: 0.8em;
    /* Keep font size */
    color: rgba(255, 255, 255, 0.8);
    /* Keep color */
    margin-bottom: 0;
    /* Removed bottom margin */
}

.job-detail-link {
    display: flex;
    /* Make link container a flex item */
    align-items: center;
    /* Vertically align link text and arrow */
}

.job-detail-link a {
    color: white;
    /* White link color */
    text-decoration: none;
    /* Remove underline */
    font-size: 0.8em;
    /* Keep font size */
    white-space: nowrap;
    /* Prevent wrapping */
    display: flex;
    align-items: center;
    /* Vertically align text and arrow */
    gap: 5px;
    /* Space between text and arrow */
}

.job-detail-link a:hover {
    text-decoration: underline;
    /* Add underline on hover */
}

.pagination {
    margin-top: 15px;
    /* Reduced margin */
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.pagination button {
    margin: 0 3px;
    /* Reduced margin */
    padding: 6px 12px;
    /* Reduced padding */
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.pagination button:hover:not(:disabled) {
    background-color: #f0f0f0;
}

.pagination button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.pagination button.active {
    background-color: #ac6249;
    color: white;
    border-color: #ac6249;
}

.pagination select {
    margin-left: 15px;
    /* Reduced margin */
    padding: 6px;
    /* Reduced padding */
    border-radius: 4px;
    border: 1px solid #ccc;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    .talent-container {
        padding: 15px;
        margin: 20px 10px;
        margin-top: -30px;
    }

    .talent-intro-card {
        padding: 20px;
        border-radius: 8px;
    }

    .card-title {
        font-size: 20px;
    }

    .english-subtitle {
        font-size: 16px;
        display: block;
        margin-top: 5px;
    }

    .section-title {
        font-size: 18px;
    }

    .job-list {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .job-item {
        max-width: 100%;
        flex-direction: column;
        align-items: flex-start;
        padding: 15px;
        gap: 12px;
    }

    .job-details {
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        margin-right: 0;
        gap: 10px;
    }

    .job-title-location {
        width: 100%;
    }

    .job-title {
        font-size: 16px;
    }

    .job-location {
        font-size: 13px;
    }

    .job-compensation-education {
        width: 100%;
        flex-direction: row;
        justify-content: space-between;
    }

    .job-compensation {
        font-size: 15px;
    }

    .job-education {
        font-size: 13px;
    }

    .job-detail-link {
        width: 100%;
        justify-content: flex-end;
    }

    .job-detail-link a {
        font-size: 14px;
    }

    .pagination {
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 20px;
    }

    .pagination button {
        padding: 6px 12px;
        font-size: 14px;
    }

    .pagination select {
        margin-left: 0;
        width: 100%;
        padding: 8px;
    }
}

@media screen and (max-width: 480px) {
    .talent-container {
        padding: 10px;
        margin: 15px 5px;
        margin-top: -20px;
    }

    .talent-intro-card {
        padding: 15px;
    }

    .card-title {
        font-size: 18px;
    }

    .english-subtitle {
        font-size: 14px;
    }

    .section-title {
        font-size: 16px;
    }

    .job-item {
        padding: 12px;
    }

    .job-title {
        font-size: 15px;
    }

    .job-location {
        font-size: 12px;
    }

    .job-compensation {
        font-size: 14px;
    }

    .job-education {
        font-size: 12px;
    }

    .pagination button {
        padding: 5px 10px;
        font-size: 12px;
    }
}
</style>